<!--
 * @Author: wankong
 * @Desc: 
 * @Date: 2021-12-09 21:15:12
 * @LastEditTime: 2022-01-10 15:47:19
-->
<template>
  <div class="home">
    <MHeader class="header"></MHeader>
    <MMain id="Main"></MMain>
    <transition name="fade">
      <Result v-if="showRes.show"></Result>
    </transition>
    <Products id="Product"></Products>
    <Advantage id="Why"></Advantage>
    <More></More>
    <MFooter class="footer"></MFooter>
  </div>
</template>

<script>
import MHeader from "@/components/Home/MHeader";
import MFooter from "@/components/common/Footer";
import MMain from "@/components/Home/MMain";
import Products from "@/components/Home/Products";
import Advantage from "@/components/Home/Advantage";

import Result from "@/components/Home/Result";

import More from "@/components/Home/More";
export default {
  name: "Home",
  components: {
    MHeader,
    MFooter,
    MMain,
    Advantage,
    Products,
    Result,
    More,
  },
  data() {
    return {};
  },
  computed: {
    showRes() {
      return this.$store.getters.getSearchInfo;
    },
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.home,
.container {
  background: #f7f9fe;
}
.header {
  height: 60px;
  background: #fff;
}
.container {
  min-height: calc(100vh - 60px);
  height: calc(100vh - 100px);
}
.footer {
  height: 40px;
}
</style>
